import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { WebAuth } from '@555platform/author.js';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const styles = {
  // /* landing-signin-section */landing-signin-section
  landingSigninSection: {
    boxShadow: '0px -5px 49px 0px rgba(1, 1, 1, 0.05)',
    backgroundColor: '#fff',
    height: '188px',
  },
  // .landing-signin-inner
  landingSigninInnerClass: {
    display: 'table',
    margin: 'auto',
    padding: '70px 0 0 0',
  },
  // .landing-signin-inner p
  landingSigninInnerpClass: {
    fontSize: '29px',
    color: '#282828',
    fontWeight: '500',
    lineHeight: '47px',
    margin: '0 20px',
  },
  // .landing-signin-inner .signin-btns
  SigninBtnsClass: {
    width: '154px',
    lineHeight: '47px',
    fontSize: '18px',
    fontWeight: '500',
    borderRadius: '47px',
    margin: '0 0 0 47px',
    textDecoration: 'none',
  },
  blueBtn: {
    display: 'block',
    backgroundColor: '#2fb3fa',
    color: '#fff',
    textAlign: 'center',
    cursor: 'pointer',
  },
  left: {
    float: 'left',
  },
  clearfix: {
    clear: 'both',
  },
};
const SignInSection = ({
  classes, domain, clientID, redirectURI, authServer,
}) => {
  const handleLogin = () => {
    const webAuth = WebAuth({
      domain,
      clientID,
      responseType: 'code',
      redirectURI,
      scope: 'everything',
      authServer,
    });
    webAuth.login({ state: 'xyz' });
  };
  return (
    <div className={classes.landingSigninSection}>
      <div className={classes.landingSigninInnerClass}>
        <p className={classNames(classes.landingSigninInnerpClass, classes.left)}>
          Sign-in to Create Applications or Try out Apps
        </p>
        <span
          role="presentation"
          onClick={handleLogin}
          className={classNames(classes.blueBtn, classes.left, classes.SigninBtnsClass)}
        >
          Sign-In
        </span>
        <div className={classes.clearfix} />
      </div>
    </div>
  );
};

export default withStyles(styles)(SignInSection);

SignInSection.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  domain: PropTypes.string.isRequired,
  clientID: PropTypes.string.isRequired,
  redirectURI: PropTypes.string.isRequired,
  authServer: PropTypes.string.isRequired,
};

SignInSection.defaultProps = {
  classes: {},
};
